<template>
    <div class="template-post">
        <h3>{{title}}</h3>
        <div>
            <slot/>
        </div>
        <div class="rows-buttons">
            <ButtonDefault @click.native="$emit('post')" style="margin-right: 10px; width: 150px" text="Salvar"/>
            <ButtonDefault @click.native="$emit('close')" style="width: 150px" secondary-color="true" text="Cancelar"/>
        </div>
    </div>
</template>

<script>
    import ButtonDefault from "./buttons/ButtonDefault";
    export default {
        name: "TemplatePost",
        components: {ButtonDefault},
        props:[
            'title',
        ]
    }
</script>

<style scoped>
    .template-post h3{
        font-size: 24px;
        font-family: "Roboto Black";
        color: #050B17;
        margin-bottom: 50px;
    }

    .rows-buttons{
        display: flex;
        justify-content: flex-end;
        text-align: right;
        margin-top: 50px;
    }
</style>
